export const fhbLangId = {
    ticketFhb: {
        usePage: "",
        verifyDistribution: "Bagikan tiket verifikasi",
        urgeDistribution: "Bagikan tiket penagihan",
        staffMaxDailyWorkingNumber: "Jumlah tiket maksimum setiap hari yang di kerjakan",
        ticketMaxWorkingNumber: "Jumlah maksimum tiket load setiap hari",
        ticketPartialCompletedWorkloadFactor: "部分完成工单在计算负载时占的百分比",
        ticketID: "Tiket ID",
        verifyCompleteTime: "Waktu Pengerjaan Tiket",
        ticketHandle: "Pengerjaan Tiket",
        ticketList: "List Tiket",
        waitingProcess: "Menuggu Pengerjaan",
        partialCompleted: "Selesai sebagian",
        phoneVerifyDistribution: "Bagikan tiket verifikasi",
        distributionManagement: "Manajemen Pembagian Tiket",
        phoneVerify: "Verifikasi Telepon",
        stopAcceptTicket: "Berhenti Terima Tiket",
        continueAcceptTicket: "Terima Tiket",
        qualityInspectionResults: "Hasil Pemeriksaan Kualitas",
        auditResults: "Hasil Pemeriksaan",
        creditReviewResults: "Hasil Pemeriksaan Data",
        auditType: "Jenis Pemeriksaan",
        createTime: "Waktu Pembuatan Tiket",
        TicketCategory: "Kategori Tiket",
        IndividualDeductibleAmount: "Limit Pemotongan Individu",
        GroupDeductibleAmount: "Limit Pemotongan Grup"
    },
    menuFhb: {
        creditApprovalTicketHandle: "Pengerjaan Tiket Verifikasi", 
        auditStaffManagement: "Manajemen Tiket Verifikasi",
        ticketHandle: "Pengerjaan Tiket",
        qualityInspectionTicketHandle: "Pemeriksaan Kualitas Tiket",
        workOrderProcessingList: "Pengerjaan Tiket"
    },
    robotFhb: {
        taskManagement: "Manajamen Tugas",
        robotService: "Manajemen Robot",
        robot: "Robot",
        employeeType: "Kategori Pegawai",
        remainingToBeRepaidAmount: "Sisa Pembayaran", 
        taskName: "Nama tugas",
        stratetyName: "Nama strategi",
        startTime: "Waktu dimulai",
        Time: "Waiktu dimulai - Waktu selesai",
        operator: "Operator",
        executionTime:"waktu eksekusi",
        timeSlot: "Durasi",
        morning: "Pagi",
        afternoon: "Sore",
        details: "Detail",
        DistinguishingMode: "metode pembagian"
    },
    messageFhb: {
        selectLanguage: "metode pembagian"
    }
};
